module.exports = __webpack_public_path__ + "img/Alahams_Logo.bf3c6d9b.svg";